import React, { createContext, useContext, useState, useMemo } from 'react';
import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink } from '@apollo/client';
import { getValidToken } from './authService';

const LoadingContext = createContext();
export const useLoading = () => useContext(LoadingContext);

const newURL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/graphql`
  : `https://pr-web-wordpress-egd6bfcbb4enatax.eastus-01.azurewebsites.net/graphql`;

const ApolloAppProvider = ({ children }) => {
  const [activeQueries, setActiveQueries] = useState(0);

  const updateLoading = (delta) => {
    setActiveQueries((prev) => Math.max(0, prev + delta));
  };

  const client = useMemo(() => {
    const rawClient = new ApolloClient({
      uri: newURL,
      cache: new InMemoryCache(),
    });

    return new ApolloClient({
      link: new HttpLink({
        uri: newURL,
        fetch: async (uri, options) => {
          const body = JSON.parse(options.body);
          const isGetMarketPaymentMethods = body.query.includes("GetMarketPaymentMethods");

          if (!isGetMarketPaymentMethods) {
            updateLoading(1);
          }

          try {
            const token = await getValidToken(rawClient);

            const headers = {
              ...options.headers,
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            };

            const result = await fetch(uri, { ...options, headers });

            if (!isGetMarketPaymentMethods) {
              setTimeout(() => updateLoading(-1), 2000);
            }

            return result;
          } catch (err) {
            console.error("Auth Error", err);
            updateLoading(-1);
            throw err;
          }
        },
      }),
      cache: new InMemoryCache(),
    });
  }, []);

  const isLoading = activeQueries > 0;

  return (
    <ApolloProvider client={client}>
      <LoadingContext.Provider value={isLoading}>{children}</LoadingContext.Provider>
    </ApolloProvider>
  );
};

export default ApolloAppProvider;